<footer class="container-fluid py-2 m-0">
    <div class="row m-0">
      <div class="col"> 
        <div>Caterpillar:</div>
        <div class="sg-footer__info">Confidential <span class="sg-confidential">Yellow</span></div>
      </div>
      <div class="col">
        <div>Content Owner:</div>  
        <div class="sg-footer__info"><span class="sg-content-icon">Solar Supply Chain</span>
         </div>
      </div>
      <div class="col">
        <div>Version:</div>
        <div class="sg-footer__info">
          {{Version}}
        </div>
      </div>
      <div class="col">
        <div>Webmaster:</div>
        <div class="sg-footer__info">
          <span class="sg-engg-icon">Enterprise Applications (EA)
            <mat-icon class="material-icons" style="height:18px;width:18px;" (click)="onClickOpenEmail()">email</mat-icon>
          </span>
        </div>
      </div>
      <div class="col">
        © Solar Turbines Incorporated.<br/> All rights reserved.
      </div>
      <div class="col sg-footer-logo d-flex justify-content-center">
        <img src="/assets/Images/EA_Logo_New.png" alt="logo">
      </div>
    </div>
  </footer>
